import React from 'react'
import { Tab } from 'semantic-ui-react'
import Setting from '../setting/Setting';

const panes = [
   { 
     menuItem: 'Import Rekening', 
     render: () => <Tab.Pane attached={false}><Setting /></Tab.Pane> 
   },
]

const Orgcom = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default Orgcom;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/setting/IndexSetting.js